import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { formatPrice } from '@wellbeingxltd/fe-lib/helpers'
import { ToggleButton } from 'components/ToggleButton'
import ResourcesActions from 'store/models/resources'

const Product = ({ automationType, outOfStock, priceDesc, priceFinal, priceOriginalTotal, priceType, productId, resourceId, shopifyVariantId }) => {
    const dispatch = useDispatch()
    const { outOfStockLoading } = useSelector(GET_STORE.RESOURCES)

    return (
        <div className="product-container contentHeight">
            <div className="resource-column" id={`productsV2-${productId}`}>
                {priceType === 'custom' ? (
                    <span>Custom price</span>
                ) : (
                    <span>
                        {formatPrice(priceFinal)}{' '}
                        {priceFinal !== priceOriginalTotal && <strike className="resource-priceOriginal">{formatPrice(priceOriginalTotal)}</strike>}
                    </span>
                )}
                <span className="resource-priceDesc">{priceDesc}</span>
                {automationType === 'Product' && (
                    <>
                        <ToggleButton
                            {...{
                                disabled: !!outOfStockLoading || shopifyVariantId,
                                id: `${productId}-outOfStock`,
                                label: 'Out of stock',
                                loading: outOfStockLoading === productId,
                                onChange: event =>
                                    dispatch(
                                        ResourcesActions.updateResourceProduct(
                                            {
                                                resourceId,
                                                productId,
                                                outOfStock: event.target.checked,
                                            },
                                            (message, type) => Alert(message, type)
                                        )
                                    ),
                                checked: outOfStock,
                            }}
                        />
                    </>
                )}
            </div>
        </div>
    )
}

export const ProductsList = ({ row }) =>
    row.original.productsV2 ? (
        row.original.productsV2.map(product => (
            <Product key={product.productId} {...{ automationType: row.original.automationType, resourceId: row.original.resourceId }} {...product} />
        ))
    ) : (
        <span className="error">ERROR: productsV2 is not found</span>
    )
